import { Box } from "@mui/material";
import React from "react";
import { useController } from "../assets/components/BaseContrroler";
import { Link } from "react-router-dom";

function Footer() {
  const {
    baseController: { homeController },
  } = useController();
  const { ScrollIntoViewHandle } = homeController;

  return (
    <Box component="footer">
      <div id="footer" className="p-4">
        <div className="container">
          <div className="row">
            {/* About Us */}
            <div className="col-12 col-md-6 col-lg-4 mb-4">
              <h5 className="text-center text-md-start">About Us</h5>
              <p style={{ textAlign: "justify" }}>
                <b>Karnafully International</b> was emerged in beginning 2010 by
                one young entrepreneur...
              </p>
              <a
                className="readMore"
                onClick={() => ScrollIntoViewHandle("about")}
              >
                Read more...
              </a>
            </div>

            {/* Our Services */}
            <div className="col-12 col-md-6 col-lg-4 mb-4 text-center">
              <h5>Our Services</h5>
              <ul className="list-unstyled">
                <li onClick={() => ScrollIntoViewHandle("service")}>
                  Sea Freight Forwarding
                </li>
                <li onClick={() => ScrollIntoViewHandle("service")}>
                  Custom Clearing & Forwarding
                </li>
                <li onClick={() => ScrollIntoViewHandle("service")}>
                  Consultant
                </li>
              </ul>
            </div>

            {/* Address */}
            <div className="col-12 col-lg-4 mb-4">
              <h5 className="text-center text-lg-start">Address</h5>
              <div className="row">
                <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                  <div className="footer-con-title">Corporate Office :</div>
                  <div className="footer-con-body">
                    110, Abdul Latif Market (2nd Floor)
                    <br />
                    3 No Jetty Gate, Fakirhat Road, Bandar,
                    <br />
                    Chattogram-4100.
                  </div>
                </div>
                <div className="col-12 col-sm-6">
                  <div className="footer-con-title">Dhaka Office :</div>
                  <div className="footer-con-body">
                    Unique Heights, Level-4,
                    <br />
                    117, Kazi Nazrul Islam Avenue,
                    <br />
                    Ramna, Dhaka-1217.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}

export default Footer;
